/**
 * defa.views.InvitationContainer
 * A container for invitation handling.
 * @version 1.0.0
 */
import template from 'templates/invitationContainer.jst.html'

import Container      from 'scripts/poppet/container';
import InvitationFlow from 'scripts/defa/invitations/view-invitation-flow';

const selectors = {
	regionContainer : '[data-region=invitation-container]',
};

const InvitationContainer = Container.extend({
		
		// ------------------------------------------------
		// Setup
		// ------------------------------------------------
		
	template: template,
	
	regions: {
		container : selectors.regionContainer,
	},
		
		// ------------------------------------------------
		// Event Handlers
		// ------------------------------------------------
		
		// ------------------------------------------------
		// Other functions
		// ------------------------------------------------
		
	attachView: function() {
		if( 'invitations:token' === this.options.view ) {
			this._showInvitationsWithToken();
		}
	},
		
		/**
		 * Attaches invitation flow view.
		 * @void
		 */
	_showInvitationsWithToken: function () {
		let invitationFlow = new InvitationFlow(_.extend( this.options,{}));
		this.showChildView( 'container', invitationFlow );
	}
	
});

export default InvitationContainer;
